export default "__VITE_ASSET__CBYaHYzF__"